import BaseService from '../../middleware/BaseService';

class LinkAccountService extends BaseService {
  prefix = '/pfm-user-migration';
}

export default new LinkAccountService();
